export default function authHeader() {
  // return authorization header with jwt token
  let token = localStorage.getItem("token");
  if (token) {
    return {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    };
  } else {
    return {};
  }
}

export const getDataToken = () => {
  const token = localStorage.getItem("token");

  if (!token) return {};

  // se limpia el token
  const binString = token
    .split(".")[1]
    .replace(/-/g, "+")
    .replace(/_/g, "/");

  const payload = JSON.parse(atob(binString));
  return payload;
};
